import Emitter from '@resources/js/helpers/Emitter'
import { format, sameDay } from '@formkit/tempo'

const LOCALE = shared.options.language.code || 'en'

const STORE_FORMATTERS = {
	checkIn: date => format(date, { date: 'long' }, LOCALE),
	checkOut: date => format(date, { date: 'long' }, LOCALE),
}

export default class FormPresenter extends Emitter {
	#view
	#store

	constructor(view, store) {
		super()
		this.#view = view
		this.#store = store

		this.#init()
	}

	#init() {
		this.#syncViewDatesWithStore()
		this.#initEvents()
	}

	#initEvents() {
		// Підписка на зміну дат у View
		this.#view.on('dates-changed', ({ checkIn, checkOut }) => {
			this.#updateStoreDates(checkIn, checkOut)
		})

		// Підписка на submit
		this.#view.on('form-submit', formData => {
			this.#handleSubmit(formData)
		})

		// Підписка на зміну в Store
		this.#store.on('change', ({ name, value }) => {
			this.#handleStoreChange(name, value)
		})
	}

	#syncViewDatesWithStore() {
		const checkIn = this.#store.getProperty('checkIn')
		const checkOut = this.#store.getProperty('checkOut')

		this.#updateViewDates(checkIn, checkOut)
	}

	#updateViewDates(checkIn, checkOut) {
		this.#view.update({ checkIn: this.#formatDate(checkIn) })
		this.#view.update({ checkOut: this.#formatDate(checkOut) })
	}

	#checkIsSameDay(date1, date2) {
		return sameDay(date1, date2)
	}

	#handleStoreChange(name, value) {
		const formatter = STORE_FORMATTERS[name]

		const updateObj = {
			[name]: formatter ? formatter(value) : value,
		}

		this.#view.update(updateObj)
	}

	#formatDate(date) {
		return format(date, { date: 'long' }, LOCALE)
	}

	#updateStoreDates(checkIn, checkOut) {
		if (
			checkIn &&
			!this.#checkIsSameDay(checkIn, this.#store.getProperty('checkIn'))
		) {
			this.#store.setProperty('checkIn', checkIn)
		}

		if (
			checkOut &&
			!this.#checkIsSameDay(checkOut, this.#store.getProperty('checkOut'))
		) {
			this.#store.setProperty('checkOut', checkOut)
		}
	}

	#handleSubmit() {
		this.emit('form-submit', this.#store.getData())
	}
}
